import { Box, CircularProgress, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import {
  getConcatenatedTempleNames,
  getImageListFromTemple,
  getTempleName,
  truncateToTwoDecimals,
} from "../../utils/HelperFunctions";
import { LOCALSTORAGE_KEY } from "../../utils/Constants";
import React, { useCallback, useEffect, useState } from "react";
import { LOCALIZATION } from "../../utils/localization";
import { useTranslation } from "react-i18next";
import "../Temple/TempleView.scss";
import NoPackageAvailable from "../../components/noPackageAvailable/NoPackageAvailable";
import ChadhavaTempleContent from "../../components/BlogContent/ChadhavaTempleContent";
import { useSearchParams } from "react-router-dom";
import MasonryGrid from "../../components/MasonryGrid/MasonryGrid";
import TempleServiceListCard from "../../components/card/TempleServiceListCard/TempleServiceListCard";

function ChadhavaView(props: any) {
  const { chadhavaPackagesList, temple } = props;
  const { t } = useTranslation();

  const [searchParams, setSearchParams] = useSearchParams();

  const savedLanguage =
    localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en";

  const [isSubscriptionSelected, setIsSubscriptionSelected] = useState<
    "single" | "subscription"
  >(searchParams.get("subscription") === "true" ? "subscription" : "single");

  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    if (isSubscriptionSelected === "subscription") {
      if (params.get("subscription") !== "true") {
        params.set("subscription", "true");
        setSearchParams(params, { replace: true });
      }
    } else {
      if (params.has("subscription")) {
        params.delete("subscription");
        setSearchParams(params, { replace: true });
      }
    }
  }, [isSubscriptionSelected]);

  const priceConversionState = useSelector(
    (state: any) => state.priceConversion
  );
  const {
    rate = 1,
    currencySymbols = "₹",
    isOverseas = false,
  } = priceConversionState.priceConversionRate || {};

  const handleSubsClick = (type: "single" | "subscription") => {
    setIsSubscriptionSelected(type);
  };

  return (
    <Box className="pageContainer templePage">
      <Box className="templeBlock">
        <Grid container spacing={1}>
          <Grid item xs={12} md={2} lg={2} xl={2} className="templeLeftBlock" />

          <Grid item xs={12} md={8} lg={8} xl={8}>
            <Box className="chadhavaCenterBlock">
              {props?.isLoading && (
                <Box className="loaderContainer">
                  <CircularProgress />
                </Box>
              )}
              {/* 
              <Box className="chadhavaSubscriptionAreaSwitch">
                <Box className="chadhavaSwitch">
                  <Box
                    className={`switchOption ${
                      isSubscriptionSelected === "single" ? "active" : ""
                    }`}
                    onClick={() => handleSubsClick("single")}
                  >
                    <span className="label">
                      {t(LOCALIZATION.Single_Time_Chadhava)}
                    </span>
                  </Box>

                  <Box
                    className={`switchOption ${
                      isSubscriptionSelected === "subscription" ? "active" : ""
                    }`}
                    onClick={() => handleSubsClick("subscription")}
                  >
                    <span className="label">
                      {t(LOCALIZATION.Chadhava_Subscription)}
                    </span>
                    <span className="newBadge">{t(LOCALIZATION.Save_More)}</span>
                  </Box>
                </Box>
              </Box> */}

              <Box
                className="chadhavaGridContainer"
                sx={{ paddingBottom: { md: "30px", xs: "15px" } }}
                data-scroll-id={"all-chadhava-list"}
              >
                {/* --- Single Chadhava List --- */}
                {isSubscriptionSelected === "single" &&
                  props.templeList &&
                  props.templeList.length > 0 && (
                    <MasonryGrid
                      items={props.templeList}
                      renderItem={(item: any, id: number) => {
                        // Logic for Single Temple Cards
                        const templeName = getTempleName(item, savedLanguage);

                        const singleChadhavaImg =
                          item?.personalInfo?.media?.chadhavaTempleCardImg
                            ?.length > 0
                            ? item?.personalInfo?.media
                                ?.chadhavaTempleCardImg[0]?.pictureUrl ?? ""
                            : "";

                        const chadhavaTempleImg =
                          getImageListFromTemple(
                            item?.personalInfo,
                            "chadavaPictures"
                          )?.find((img: any) => img?.pictureUrl)?.pictureUrl ||
                          null;

                        const finalCardImage = singleChadhavaImg
                          ? singleChadhavaImg
                          : chadhavaTempleImg;

                        const city = item?.personalInfo?.address?.city ?? "";
                        const state = item?.personalInfo?.address?.state ?? "";
                        const templeAddress = `${city}${
                          city && state ? ", " : ""
                        }${state}`;

                        const benefitNames = item?.chadhavaBenefits?.map(
                          (benefit: any) => benefit?.name
                        );

                        const chadhavaTitle = item?.chadhavaTitle || templeName;

                        // Price Calculation
                        const indiaStartingPrice =
                          item?.startingPrice?.india?.finalPrice ?? 0;
                        const overseasStartingPrice =
                          item?.startingPrice?.overseas?.finalPrice ?? 0;
                        const indiaOfferPrice =
                          item?.startingPrice?.india?.offerActualPrice ?? 0;
                        const overseasOfferPrice =
                          item?.startingPrice?.overseas?.offerActualPrice ?? 0;

                        const finalTotalPrice = isOverseas
                          ? truncateToTwoDecimals(overseasStartingPrice * rate)
                          : Math.ceil(indiaStartingPrice);

                        const offerActualPrice = isOverseas
                          ? truncateToTwoDecimals(overseasOfferPrice * rate)
                          : Math.ceil(indiaOfferPrice);

                        return (
                          <TempleServiceListCard
                            key={`templeCenterBlock${id}`}
                            id={id}
                            templeData={item}
                            templeCardImage={finalCardImage}
                            overlayText={
                              item?.personalInfo?.overlayText
                                ?.chadhavaTempleOverlayText ?? null
                            }
                            overlayCss={
                              item?.personalInfo?.overlayCss
                                ?.chadhavaTempleOverlayCss ?? null
                            }
                            templeName={templeName}
                            templeAddress={templeAddress}
                            selectTemple={props.selectTemple}
                            serviceTitle={item?.chadhavaCardDescription}
                            serviceDescription={chadhavaTitle}
                            serviceBenefits={benefitNames}
                            serviceThithiName={item?.chadhaveTithiName || ""}
                            finalTotalPrice={finalTotalPrice}
                            offerActualPrice={offerActualPrice}
                            currencySymbols={currencySymbols}
                            type={item?.type}
                            actionLabel={t(LOCALIZATION.Offer_Chadhava)}
                          />
                        );
                      }}
                    />
                  )}

                {/* --- Subscription Packages List --- */}
                {isSubscriptionSelected === "subscription" && (
                  <>
                    {chadhavaPackagesList && chadhavaPackagesList.length > 0 ? (
                      <MasonryGrid
                        items={chadhavaPackagesList}
                        renderItem={(pkgItem: any, id: number) => {
                          // Logic for Subscription Cards
                          const packageImage = pkgItem?.pujaBg?.uri ?? "";
                          const packageName = pkgItem?.pujaName ?? "";
                          const benefitNames =
                            pkgItem?.benefitList?.map(
                              (benefit: any) => benefit?.name
                            ) ?? [];

                          const indiaBasic = pkgItem?.indianBasicPrice ?? 0;
                          const overseasBasic =
                            pkgItem?.overseasBasicPrice ?? 0;

                          const finalTotalPrice = isOverseas
                            ? truncateToTwoDecimals(overseasBasic * rate)
                            : truncateToTwoDecimals(indiaBasic);

                          const indianOfferActualPrice =
                            pkgItem?.priceBreakupV1?.india?.pujaWithoutPrasad
                              ?.offerActualPrice ?? 0;

                          const overseasOfferActualPrice =
                            pkgItem?.priceBreakupV1?.overseas?.pujaWithoutPrasad
                              ?.offerActualPrice ?? 0;

                          const actualOfferPrice = isOverseas
                            ? truncateToTwoDecimals(
                                overseasOfferActualPrice * rate
                              )
                            : truncateToTwoDecimals(indianOfferActualPrice);

                          const savedLanguage =
                            localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ??
                            "en";

                          const templeName = getTempleName(
                            { personalInfo: temple },
                            savedLanguage
                          );
                          const packageTempleName = getConcatenatedTempleNames(
                            pkgItem?.templeList
                          );
                          const templeFinalName = templeName
                            ? templeName
                            : packageTempleName;

                          return (
                            <TempleServiceListCard
                              key={`templePackageBlock${id}`}
                              id={id}
                              templeData={pkgItem}
                              templeCardImage={packageImage}
                              overlayText={{
                                leftSideTextOverlay:
                                  pkgItem?.leftSideTextOverlay ?? null,
                                rightSideTextOverlay:
                                  pkgItem?.rightSideTextOverlay ?? null,
                              }}
                              overlayCss={pkgItem?.overlayCss ?? null}
                              templeName={templeFinalName}
                              selectTemple={props?.selectChadhavaPackageTemple}
                              serviceTitle={pkgItem?.cardTitle}
                              serviceDescription={packageName}
                              serviceBenefits={benefitNames}
                              serviceThithiName={pkgItem?.tithiName || ""}
                              finalTotalPrice={finalTotalPrice}
                              offerActualPrice={actualOfferPrice}
                              currencySymbols={currencySymbols}
                              type={pkgItem?.type}
                              actionLabel={t(LOCALIZATION.Book_Package)}
                            />
                          );
                        }}
                      />
                    ) : (
                      <NoPackageAvailable
                        message={t("No_packages_available")}
                      />
                    )}
                  </>
                )}
              </Box>
            </Box>
          </Grid>

          <Grid
            item
            xs={12}
            md={2}
            lg={2}
            xl={2}
            className="templeRightBlock"
          />
        </Grid>
        <Box className="bottomBlogContent">
          <ChadhavaTempleContent />
        </Box>
      </Box>
    </Box>
  );
}

export default ChadhavaView;
